export default __webpack_public_path__ + "static/media/SDG-icon-NL-15.cea75936.svg";